import { useEffect, useState } from "react";
import { Fab } from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

export default function ScrollToTop() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setShowTop(window.pageYOffset > 400);
    };
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (!showTop) return null;

  return (
    <Fab
      onClick={scrollToTop}
      size="medium"
      sx={{
        position: "fixed",
        bottom: 96,
        right: 16,
        bgcolor: "black",
        color: "white",
        boxShadow: 6,
        zIndex: 1200,
        "&:hover": { bgcolor: "#333" },
      }}
      aria-label="scroll to top"
    >
      <KeyboardArrowUpIcon />
    </Fab>
  );
}
